module.exports = __webpack_public_path__ + "static/media/federal.596fae08.jpg";